import { ListItemIcon, ListItemText, MenuItem } from '@mui/material'
import { Edit2, Eye, Trash2 } from 'react-feather'

// Imports custom
import {
    TooltipInformation,
    CustomTableData,
    LinearLoading,
    CustomDropDown
} from 'common'

export const TableLegalDocuments = ({ useFetchInit }) => {
    
    const {
        FetchData,
        Actions
    } = useFetchInit

    const { fetchAllLegalDocuments } = FetchData
    const { dataLegalDocuments, loadingFetchAllLegalDocuments } = fetchAllLegalDocuments

    const { 
        handleClickFetchSpecificLegalDocument,
        handleClickDeleteLegalDocument
    } = Actions

    const columnConfig = [
        {
            //FIELD PARA TOOLTIP
            headerName: 'Info',
            maxWidth: 80,
            cellStyle: () => ({
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }),
            cellRenderer: (params) => {
                //DESESTRUCTURACIÓN DE DATA PARA MOSTRAR EN TOOLTIP
                const { usuario_creo, fecha_creo, usuario_modifico, fecha_modifico } = params.data
                return (
                    <TooltipInformation
                        usuario_creo={usuario_creo}
                        fecha_creo={fecha_creo}
                        usuario_modifico={usuario_modifico}
                        fecha_modifico={fecha_modifico}
                    />
                )
            }
        },
        { field: "date_document", headerName: "FECHA", minWidth: 150, filter: true },
        { field: "category_process", headerName: "CATEGORIA", minWidth: 150, filter: true },
        { field: "type_process", headerName: "TIPO", minWidth: 150, filter: true },
        { field: "name_process", headerName: "DOCUMENTO", minWidth: 400, filter: true },
        { field: "jdo_process_number", headerName: "PROCESO (JUZGADO)", minWidth: 300, filter: true },
        { field: "observations", headerName: "DESCRIPCION", minWidth: 300, filter: true },
        { field: "process_number", headerName: "PROCESO", minWidth: 300, filter: true },
        {
            headerName: 'Opciones',
            minWidth: 350,
            cellRenderer: (params) => {
                const { iddocument } = params.data
                return (
                    <CustomDropDown>
                        <MenuItem
                            onClick={() => handleClickFetchSpecificLegalDocument(iddocument)}
                        >
                            <ListItemIcon> <Eye color="black"/> </ListItemIcon>
                            <ListItemText primary="Información" />
                        </MenuItem>
                        <MenuItem
                            onClick={() => handleClickDeleteLegalDocument(iddocument)}
                        >
                            <ListItemIcon> <Trash2 color="black"/> </ListItemIcon>
                            <ListItemText primary="Eliminar" />
                        </MenuItem>
                    </CustomDropDown>
                )
            }
        }
    ]

    return (
        <div className='content'>
            {(loadingFetchAllLegalDocuments)&&(<LinearLoading />)}
            <CustomTableData
                rowConfig={dataLegalDocuments}
                columnConfig={columnConfig}
            />
        </div>
    )
}
